"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _state = require("@seedlang/state");
var _review_due_helpers = require("./review_due_helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function cardIdsMatch(a, b) {
  if (a == null || b == null) {
    return false;
  }
  return String(a) === String(b);
}
var ReviewHistoryWrapper = function ReviewHistoryWrapper(Component) {
  var _class;
  return (0, _mobxReact.observer)((_class = /*#__PURE__*/function (_React$Component) {
    function _class() {
      _classCallCheck(this, _class);
      return _callSuper(this, _class, arguments);
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "cardId",
      get: function get() {
        var _this$props$route, _this$props$card, _DeckUI$currentCard;
        if ((_this$props$route = this.props.route) !== null && _this$props$route !== void 0 && (_this$props$route = _this$props$route.params) !== null && _this$props$route !== void 0 && _this$props$route.cardId) {
          return this.props.route.params.cardId;
        }
        if ((_this$props$card = this.props.card) !== null && _this$props$card !== void 0 && _this$props$card.id) {
          return this.props.card.id;
        }
        if (this.props.cardId) {
          return this.props.cardId;
        }
        return (_DeckUI$currentCard = _state.DeckUI.currentCard) === null || _DeckUI$currentCard === void 0 ? void 0 : _DeckUI$currentCard.id;
      }
    }, {
      key: "card",
      get: function get() {
        var _AppUI$cardStore$show, _DeckUI$currentCard2, _AppUI$cardStore$show2;
        if (this.props.card) {
          return this.props.card;
        }
        if (this.cardId && cardIdsMatch((_AppUI$cardStore$show = _state.AppUI.cardStore.showData) === null || _AppUI$cardStore$show === void 0 ? void 0 : _AppUI$cardStore$show.id, this.cardId)) {
          return _state.AppUI.cardStore.showData;
        }
        if (this.cardId && cardIdsMatch((_DeckUI$currentCard2 = _state.DeckUI.currentCard) === null || _DeckUI$currentCard2 === void 0 ? void 0 : _DeckUI$currentCard2.id, this.cardId)) {
          return _state.DeckUI.currentCard;
        }
        return this.cardId ? null : (_AppUI$cardStore$show2 = _state.AppUI.cardStore.showData) !== null && _AppUI$cardStore$show2 !== void 0 && _AppUI$cardStore$show2.id ? _state.AppUI.cardStore.showData : _state.DeckUI.currentCard;
      }
    }, {
      key: "reviewsDueAtBeginningOfDayValue",
      get: function get() {
        var _AppUI$user;
        if (typeof this.props.reviewsDueAtBeginningOfDayValue !== 'undefined') {
          return this.props.reviewsDueAtBeginningOfDayValue;
        }
        return (_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.reviewsDueAtBeginningOfDay;
      }
    }, {
      key: "reviewAfterText",
      get: function get() {
        var _this$card;
        return (0, _review_due_helpers.formatReviewAfterText)((_this$card = this.card) === null || _this$card === void 0 ? void 0 : _this$card.reviewAfter, this.reviewsDueAtBeginningOfDayValue);
      }
    }, {
      key: "isReviewPastDue",
      get: function get() {
        var _this$card2;
        return (0, _review_due_helpers.reviewIsPastDue)((_this$card2 = this.card) === null || _this$card2 === void 0 ? void 0 : _this$card2.reviewAfter, this.reviewsDueAtBeginningOfDayValue);
      }
    }, {
      key: "showExactReviewAfter",
      get: function get() {
        return (0, _review_due_helpers.showExactReviewAfter)(this.reviewsDueAtBeginningOfDayValue);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          card: this.card,
          reviewAfterText: this.reviewAfterText,
          isReviewPastDue: this.isReviewPastDue,
          showExactReviewAfter: this.showExactReviewAfter
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class.prototype, "cardId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "card", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "card"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewsDueAtBeginningOfDayValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewsDueAtBeginningOfDayValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewAfterText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewAfterText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReviewPastDue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReviewPastDue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExactReviewAfter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showExactReviewAfter"), _class.prototype), _class));
};
ReviewHistoryWrapper.displayName = 'ReviewHistoryWrapper';
var _default = exports["default"] = ReviewHistoryWrapper;